import React, { useState } from 'react';

import { Modal, Button, FormGroup, ControlLabel, Checkbox } from '@shared/components/bootstrap';
import { TextAreaFormControl } from '@shared/components/fields/text_area_form_control';

import { type DispatcherInstructionsForm, type DispatcherInstructionsFormAddon } from './dispatcher_instruction_form';

const ADDONS: Array<{
  value: DispatcherInstructionsFormAddon;
  label: string;
}> = [
  {
    value: 'fragile',
    label: 'Fragile',
  },
  {
    value: 'furniture',
    label: 'Furniture',
  },
  {
    value: 'box_heavy',
    label: 'Box Heavy',
  },
  {
    value: 'tags',
    label: 'Tags',
  },
];

export const DispatcherInstructionsDialog: React.FC<{
  form: DispatcherInstructionsForm;
  onSave(_: DispatcherInstructionsForm): void;
  onClose(): void;
}> = ({ onSave, onClose, ...props }) => {
  const [form, setForm] = useState<DispatcherInstructionsForm>({
    addons: props.form.addons,
    load_out: props.form.load_out,
    warehouse_notes: props.form.warehouse_notes,
    mover_notes: props.form.mover_notes,
  });

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onSave(form);
  };

  return (
    <Modal onClose={onClose}>
      <Modal.Content>
        <form onSubmit={onSubmit}>
          <Modal.Header>
            <Modal.Title>Materials/Instructions</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <ControlLabel htmlFor="load_out">Warehouse Load Out:</ControlLabel>
              <select
                id="load_out"
                className="form-control"
                value={form.load_out ?? ''}
                onChange={(event) => setForm({ ...form, load_out: event.target.value || undefined })}
              >
                <option value="">- Load Out -</option>
                <option value="standard">Standard</option>
                <option value="plus">Plus</option>
                <option value="equipment_only">Equipment Only</option>
              </select>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Warehouse Add-ons:</ControlLabel>
              {ADDONS.map((addon, key) => (
                <Checkbox key={key}>
                  <input
                    type="checkbox"
                    checked={form.addons?.includes(addon.value)}
                    onChange={(event) => {
                      const checked = event.target.checked;
                      const addons = checked
                        ? [...(form.addons ?? []), addon.value]
                        : (form.addons ?? []).filter((value) => value !== addon.value);
                      setForm({ ...form, addons });
                    }}
                  />
                  {addon.label}
                </Checkbox>
              ))}
            </FormGroup>
            <FormGroup>
              <ControlLabel htmlFor="warehouse_notes">Warehouse Notes:</ControlLabel>
              <TextAreaFormControl
                id="warehouse_notes"
                value={form.warehouse_notes ?? ''}
                onChange={(event) => {
                  setForm({ ...form, warehouse_notes: event.target.value || undefined });
                }}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel htmlFor="mover_notes">Mover Notes:</ControlLabel>
              <TextAreaFormControl
                id="mover_notes"
                value={form.mover_notes ?? ''}
                onChange={(event) => {
                  setForm({ ...form, mover_notes: event.target.value || undefined });
                }}
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" kind="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" kind="primary">
              Done
            </Button>
          </Modal.Footer>
        </form>
      </Modal.Content>
    </Modal>
  );
};
